module.exports = __webpack_public_path__ + "img/docker.1fe3c9c5.svg";